export default class Clock {
  timeAcc = 0; // 暂停的时间 ms
  startMoment = new Date();
  clock: NodeJS.Timeout | null = null;
  time = 0; // 显示的时间 ms

  start() {
    this.startMoment = new Date();
    const f = () => {
      const moment = new Date();
      this.time = moment.valueOf() - this.startMoment.valueOf() + this.timeAcc;
    };
    this.clock = setInterval(f, 10);
  }
  pause() {
    clearInterval(this.clock as NodeJS.Timeout);
    const endMoment = new Date();
    this.timeAcc = endMoment.valueOf() - this.startMoment.valueOf() + this.timeAcc;
  }
  clear() {
    this.timeAcc = 0;
    this.startMoment = new Date();
    this.clock = null;
    this.time = 0;
  }

  get dial() {
    const t = Math.floor(this.time / 10);
    const cen = t % 100;
    const s = Math.floor(t / 100);
    const sec = s % 60;
    const min = Math.floor(s / 60);

    const cenDial = cen.toString().padStart(2, '0');
    const secDial = sec.toString().padStart(2, '0');
    const minDial = min.toString().padStart(2, '0');
    return minDial + ':' + secDial + '.' + cenDial;
  }

  get dial_mmss() {
    const t = Math.floor(this.time / 10);
    const s = Math.floor(t / 100);
    const sec = s % 60;
    const min = Math.floor(s / 60);

    const secDial = sec.toString().padStart(2, '0');
    const minDial = min.toString().padStart(2, '0');
    return minDial + ':' + secDial;
  }
}
